module.exports = __webpack_public_path__ + "static/media/b-sci-major-34_LR.7c9d6bdf.jpg";